import { Suspense } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import useClassroomStore from '../stores/classroomStore';
import VirtualClassroom from './VirtualClassroom';
import CameraPreviewModal from './CameraPreviewModal';
import SupportChatWidget from './SupportChatWidget';
import ErrorBoundary from './ErrorBoundary';

function LoadingFallback() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-brand-cream">
      <div className="text-brand-primary text-xl font-semibold">Завантаження...</div>
    </div>
  );
}

export default function AppLayout() {
  const inClass = useClassroomStore(s => s.inClass);
  const showCameraPreview = useClassroomStore(s => s.showCameraPreview);
  const location = useLocation();
  const isLanding = location.pathname === '/';

  if (inClass) {
    return <VirtualClassroom />;
  }

  return (
    <ErrorBoundary>
      {showCameraPreview && <CameraPreviewModal />}
      <Suspense fallback={<LoadingFallback />}>
        <Outlet />
      </Suspense>
      {isLanding && <SupportChatWidget />}
    </ErrorBoundary>
  );
}
